import React, { memo } from 'react';
import { Button } from '@vmos2/design-system';

type Props = {
  onClick: Function,
  buttonText: string,
  isDisabled?: boolean,
}

export const FooterButton = memo(({ onClick, buttonText, isDisabled }: Props) => (
  <Button
    type="submit"
    contentCenter ml="auto"
    onClick={onClick}
    block
    data-test="user-address-modal-footer-button"
    disabled={isDisabled}
  >
    {buttonText}
  </Button>
));
